import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {LabelLinkQueryCriteriaClass, LabelLinkCriteriaModelQuery} from '../../../criteria/label-link-query-criteria.model';
import {LabelLinkContainerModel} from '../../../../../../models/aggregates/erp/label';
import {Core2Config} from '../../shared/core2Config';
import {ApiResponseModel, BasicApiResponseModel} from '../../shared/api-response.model';
import {ApiVisa} from '../../shared/api-visa.model';
import { LabelHeaderListContainerModel } from '../../../../../../models/aggregates/erp/label/label-header-list-container.model';

@Injectable({
  providedIn: 'root'
})
export class LabelLinkService extends BaseApiTemplateService<LabelLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'labels-link';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'labels-link';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'labels-link';
    this.httpClient = http;
  }

  getPromiseByCriteria(
    visa: ApiVisa, criteria?: LabelLinkQueryCriteriaClass
  ): Promise<ApiResponseModel<LabelLinkContainerModel>> {
    const buildDocCriteria = new LabelLinkCriteriaModelQuery(criteria);
    console.log('buildDocCriteria: ', buildDocCriteria);
    console.log('OverRide: ', buildDocCriteria.query);
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    //  const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query + ' offset ' + buildDocCriteria.voucherHdrCriteria.offset * buildDocCriteria.voucherHdrCriteria.limit + ' limit ' + buildDocCriteria.voucherHdrCriteria.limit;
    console.log('UrlByCriteria: ', UrlByCriteria);
    return this.httpClient.get<ApiResponseModel<LabelLinkContainerModel>>
    (UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }

  getPromiseByCriteriaBasic(
    visa: ApiVisa, criteria?: LabelLinkQueryCriteriaClass
  ): Promise<BasicApiResponseModel<LabelLinkContainerModel>> {
    const buildDocCriteria = new LabelLinkCriteriaModelQuery(criteria);
    console.log('buildDocCriteria: ', buildDocCriteria);
    console.log('OverRide: ', buildDocCriteria.query);
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    //  const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query + ' offset ' + buildDocCriteria.voucherHdrCriteria.offset * buildDocCriteria.voucherHdrCriteria.limit + ' limit ' + buildDocCriteria.voucherHdrCriteria.limit;
    console.log('UrlByCriteria: ', UrlByCriteria);
    return this.httpClient.get<BasicApiResponseModel<LabelLinkContainerModel>>
    (UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }

  getAllLabelByItemGuid(guid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + `/get-by-item/${guid}`;
    return this.httpClient.get<ApiResponseModel<LabelHeaderListContainerModel>>(
      url, this.getHttpHeader(visa)
    );
  }
}